<template>
  <div>
    <el-dialog
      width="650px"
      title="审核"
      :visible.sync="visibleFlag"
      @close="handleColse"
    >
      <div>
        <p class="mb-2">
          <label style="width: 60px;" class="text-right inline-block mr-1">得分</label>
          <el-input-number v-model="sumScore" :min="0" />
        </p>
        <div class="flex justify-between">
          <label style="width: 60px;" class="text-right mr-1">问题说明</label>
          <div class="flex-1">
            <div v-for="(item, index) in problemList" :key="item.id" class="bg-theme-gray p-2 mb-2 relative problem-item">
              <i v-if="(problemList.length>1)" class="el-icon-delete text-transparent absolute top-0 -right-4 cursor-pointer" @click="onDel(item.id)"></i>
              <el-select class="bg-white-input mr-2" v-model="item.firstlevelContent" placeholder="请选择" @input="changeFirstLevel($event, item.id)">
                <el-option
                  v-for="option in level1List"
                  :key="option.id"
                  :label="option.content"
                  :value="option.content"/>
              </el-select>
              <el-select class="bg-white-input" v-model="item.secondLevelContent" placeholder="请选择" @input="changeSecondLevel($event, item.id)">
                <el-option
                  v-for="option in level2List"
                  :key="option.id"
                  :label="option.content"
                  :value="option.content"/>
              </el-select>
              <p class="my-2 leading-22">{{item.firstlevelContent}}</p>
              <p class="leading-22" v-html="getSecondLevelRichText(item.secondLevelContent)"></p>
              <el-upload
                class="mt-2"
                action="/fill/api/v1/upload"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-remove="(...event) =>{handleRemove(event, index)}"
                :on-success="(...event) =>{handleSuccess(event, index)}"
                :before-upload="beforeUpload"
                >
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
            <el-button v-if="isShowAddBtn" size="medium" type="primary" @click="onAdd" class="rounded-sm my-0 mx-auto block">
              <span><i class="el-icon-plus mr-1 font-bold"></i>添加问题</span>
            </el-button>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="normal-button" @click="handleColse">取消</el-button>
        <el-button type="primary" @click="onSubmit">
          提交审核
        </el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible" append-to-body>
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import { queryDownConfig, addScore, addScoreList } from '@/api/wenjuan/qualityControl'
import { mapGetters } from 'vuex'
import GlobalConfig from '@/global/config'

export default {
  name: 'SmartStoreAudit',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    answerId: {
      type: String,
      default: ''
    },
    answerIds: {
      type: Array,
      default: ()=>([])
    },
    surveyFinishTime: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      problemList: [],
      sumScore: 0,
      level1List: [],
      level2List: [],
      dialogVisible: false, //查看大图
      dialogImageUrl: '',
      fileList: []
    }
  },
  computed: {
    visibleFlag: {
      get() {
        return this.visible
      },
      set(v) {
        this.$emit('update:visible', v)
      }
    },
    isShowAddBtn() {
      const lastOne = this.problemList[this.problemList.length-1]
      return lastOne?.firstlevelContent && lastOne?.secondLevelContent && lastOne?.imgUrl?.length
    },
    getSecondLevelRichText() {
      return function(text) {
        if(text.includes('严重违规')) {
          return text.replace('严重违规', '<span class="text-danger">严重违规</span>')
        }
        return text
      }
    },
    ...mapGetters(['userInfo']),
  },
  methods: {
    onSubmit(){
      if(!this.checkSubmit()) {
        return
      }
      let api = addScore;
      let data = {
        wjSurveyId: GlobalConfig.getSurveyId(),
        customerId: this.userInfo.baseId,
        surveyAnswerId: this.answerId,
        finishTime: this.surveyFinishTime,
        sumScore: this.sumScore,
        mobileScoreVOList: this.problemList.map(item => ({
          firstlevelContent: item.firstlevelContent,
          firstlevelContentId: item.firstlevelContentId,
          secondLevelContent: item.secondLevelContent,
          secondLevelContentId: item.secondLevelContentId,
          imgUrl: item.imgUrl.map(item => item.response.data.url)
        }))
      }
      if(this.answerIds.length) {
        data = this.answerIds.map(item => ({
          ...data,
          surveyAnswerId: item
        }))
        api = addScoreList
      }
      api(data).then(res=>{
        if(res.data.code !== 0) {
          this.$message.warning(res.data.msg || '审核失败')
          return
        }
        // this.$message.success(res.data.msg || '审核成功')
        // this.handleColse()
        this.$emit('add-audit-success')
      })
    },
    checkSubmit() {
      let res = true
      try {
        this.problemList.forEach(element => {
          if(!element.firstlevelContent || !element.secondLevelContent || !element.imgUrl.length) {
            throw new Error('请完善问题说明')
          }
        })
      } catch(e) {
        this.$message.warning(e.message)
        res = false
      }
      return res
    },
    onDel(id) {
      const idx = this.problemList.findIndex(item => item.id === id)
      this.problemList.splice(idx, 1)
    },
    onAdd() {
      this.problemList.push(this.getProblemListInit())
    },
    getProblemListInit() {
      return {
        id: Date.now(),
        firstlevelContent: '',
        secondLevelContent: '',
        imgUrl: []
      }
    },
    changeFirstLevel(val, id) {
      const idx = this.problemList.findIndex(item => item.id === id)
      this.problemList[idx].secondLevelContent = ''
      const parentId = this.level1List.find(item => item.content === val).id
      this.problemList[idx].firstlevelContentId = parentId
      this.getDownConfig(2, parentId).then(res=>{
        this.level2List = res
      })
    },
    changeSecondLevel(val, id) {
      const idx = this.problemList.findIndex(item => item.id === id)
      const idVal = this.level2List.find(item => item.content === val).id
      this.problemList[idx].secondLevelContentId = idVal
    },
    //获取下拉调用接口
    getDownConfig(level = 1, parentId = 0) {
     return new Promise((resolve, reject)=>{
      queryDownConfig({level, parentId }).then(res=>{
        if(res.data.code !== 0) {
            this.$message.warning(res.data.msg || '获取失败')
            return
          }
          resolve(res.data.data)
        }, reject)
     })
    },
    handleColse() {
      this.visibleFlag = false
    },
    //========图片上传=========
    handleRemove(event, index ) {
      const [res, fileList] = event
      this.problemList[index].imgUrl = fileList
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleSuccess(event, index ) {
      let [res, file, fileList]  = event
      if (res && res.code !== 0) {
        // 错误提示
        this.$message.error(res.msg)
        // 删除
        const idx = fileList.findIndex(item => {
          return item.uid === file.uid
        })
        fileList.splice(idx, 1)
      }
      this.problemList[index].imgUrl = fileList
    },
    beforeUpload(file) {
      const type = ['image/png', 'image/jpeg', 'image/bmp', 'image/gif']
      const isJPG = type.includes(file.type)
      // const isLimitSize = file.size / 1024 / 1024 < size

      if (!isJPG) {
        this.$message.error('上传图片只能是 jpg、jpeg、gif、bmp、png 格式!')
      }
      // if (!isLimitSize) {
      //   this.$message.error(`上传图片大小不能超过 ${size}MB!`)
      // }
      return isJPG
    },
  },
  watch: {
    visible(n) {
      if(n) {
        this.sumScore = 0
        this.getDownConfig(1, 0).then(res => {
          this.level2List = []
          this.level1List = res
        })
        this.problemList = [this.getProblemListInit()]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .problem-item:hover {
    &>i {
      color: initial;
    }
  }
  ::v-deep .el-dialog {
    height: 75vh;
    .el-dialog__body {
      box-sizing: border-box;
      height: calc(100% - 116px);
      overflow: auto;
    }
  }
</style>